import React from 'react';
import PropTypes from 'prop-types';
import ProductSelector from './ProductSelector';

const EligibilityProductSelector = ({
  products,
  selectedProduct,
  onProductChange,
  hasUnsavedChanges,
  themeClass,
  tooltipContent,
  placeholderText,
}) => (
  <ProductSelector
    products={products}
    selectedProduct={selectedProduct}
    onProductChange={onProductChange}
    hasUnsavedChanges={hasUnsavedChanges}
    tooltipContent={tooltipContent}
    placeholderText={placeholderText}
    themeClass={themeClass}
  />
);

EligibilityProductSelector.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedProduct: PropTypes.string.isRequired,
  onProductChange: PropTypes.func.isRequired,
  hasUnsavedChanges: PropTypes.bool.isRequired,
  themeClass: PropTypes.string.isRequired,
  tooltipContent: PropTypes.string,
  placeholderText: PropTypes.string,
};

EligibilityProductSelector.defaultProps = {
  tooltipContent: 'Select the product to edit eligibility rules.',
  placeholderText: 'SELECT PRODUCT CONTEXT',
};

export default EligibilityProductSelector;
